import { ColumnState } from 'ag-grid-community';

export const getColIds = (columnState: ColumnState[], excludePinned = true) =>
  columnState?.reduce((accumulator, column) => {
    if (column.colId && (!excludePinned || !column.pinned)) {
      accumulator.push(column.colId);
    }

    return accumulator;
  }, []);
